(function () {
  'use strict';

  // Search toggle
  var searchToggles = document.querySelectorAll('.js-header-search-toggle');
  searchToggles.forEach(function (btn) {
    var panelId = btn.getAttribute('aria-controls');
    var panel = document.getElementById(panelId);
    if (!panel) return;

    btn.addEventListener('click', function () {
      if (panel.hasAttribute('hidden')) {
        openSearch(btn, panel);
      } else {
        closeSearch(btn, panel);
      }
    });

    panel.querySelectorAll('.js-header-search-close').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeSearch(btn, panel);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hasAttribute('hidden')) {
        closeSearch(btn, panel);
      }
    });
  });

  function openSearch(btn, panel) {
    panel.removeAttribute('hidden');
    btn.setAttribute('aria-expanded', 'true');
    var input = panel.querySelector('input[type="search"]');
    if (input) {
      setTimeout(function () { input.focus(); }, 50);
    }
  }

  function closeSearch(btn, panel) {
    panel.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
  }

  // Single-column mega: keep same top as full-width (bar as containing block),
  // but shift horizontally under the hovered nav link.
  function positionSingleMegaMenus() {
    if (window.matchMedia('(max-width: 900px)').matches) return;

    document.querySelectorAll('.header-nav-item--has-mega > .sub-megamenu--single').forEach(function (menu) {
      var item = menu.parentElement;
      var bar = item && item.closest('.site-header__bar');
      if (!item || !bar) return;

      var itemRect = item.getBoundingClientRect();
      var barRect = bar.getBoundingClientRect();
      var left = Math.max(0, Math.round(itemRect.left - barRect.left));
      menu.style.setProperty('--mega-left', left + 'px');
    });
  }

  function initSingleMegaMenus() {
    positionSingleMegaMenus();

    document.querySelectorAll('.header-nav-item--has-mega:has(> .sub-megamenu--single)').forEach(function (item) {
      if (item.dataset.singleMegaBound === 'true') return;
      item.addEventListener('mouseenter', positionSingleMegaMenus);
      item.addEventListener('focusin', positionSingleMegaMenus);
      item.dataset.singleMegaBound = 'true';
    });
  }

  initSingleMegaMenus();
  window.addEventListener('resize', positionSingleMegaMenus);
  document.addEventListener('shopify:section:load', initSingleMegaMenus);

  // Mobile menu — mount drawer on <body> to escape section stacking contexts
  function mountMobileMenuToBody(menu) {
    if (menu && menu.parentNode !== document.body) {
      document.body.appendChild(menu);
    }
  }

  function mountAllMobileMenus() {
    document.querySelectorAll('.mobile-menu').forEach(mountMobileMenuToBody);
  }

  function resetMobileViews(menu) {
    var root = menu.querySelector('[data-mobile-view="root"]');
    if (!root) return;
    root.classList.add('is-active');
    root.classList.remove('is-slid-out');
    menu.querySelectorAll('.mobile-menu__view--sub').forEach(function (sub) {
      sub.classList.remove('is-active');
      sub.setAttribute('hidden', '');
    });
  }

  function openMobileMenu(btn, menu) {
    mountMobileMenuToBody(menu);
    resetMobileViews(menu);
    menu.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-menu-open');
    document.body.style.overflow = 'hidden';
    var firstFocusable = menu.querySelector('.mobile-menu__search-input');
    if (firstFocusable) {
      setTimeout(function () { firstFocusable.focus(); }, 50);
    }
  }

  function closeMobileMenu(btn, menu) {
    resetMobileViews(menu);
    menu.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-menu-open');
    document.body.style.overflow = '';
    btn.focus();
  }

  function openMobileSubmenu(menu, submenuId) {
    var root = menu.querySelector('[data-mobile-view="root"]');
    var sub = menu.querySelector('[data-mobile-view="' + submenuId + '"]');
    if (!root || !sub) return;
    root.classList.remove('is-active');
    root.classList.add('is-slid-out');
    sub.removeAttribute('hidden');
    sub.classList.add('is-active');
    var backBtn = sub.querySelector('.js-mobile-submenu-back');
    if (backBtn) {
      setTimeout(function () { backBtn.focus(); }, 50);
    }
  }

  function closeMobileSubmenu(menu) {
    var root = menu.querySelector('[data-mobile-view="root"]');
    var activeSub = menu.querySelector('.mobile-menu__view--sub.is-active');
    if (activeSub) {
      activeSub.classList.remove('is-active');
      activeSub.setAttribute('hidden', '');
    }
    if (root) {
      root.classList.add('is-active');
      root.classList.remove('is-slid-out');
      var firstRow = root.querySelector('.js-mobile-submenu-open, .mobile-menu__row');
      if (firstRow) {
        setTimeout(function () { firstRow.focus(); }, 50);
      }
    }
  }

  function bindMobileMenu(menu, btn) {
    mountMobileMenuToBody(menu);

    btn.addEventListener('click', function () {
      openMobileMenu(btn, menu);
    });

    menu.querySelectorAll('.js-mobile-menu-close').forEach(function (closeEl) {
      closeEl.addEventListener('click', function () {
        closeMobileMenu(btn, menu);
      });
    });

    menu.querySelectorAll('.js-mobile-submenu-open').forEach(function (openEl) {
      openEl.addEventListener('click', function () {
        var submenuId = openEl.getAttribute('data-submenu-id');
        if (submenuId) {
          openMobileSubmenu(menu, submenuId);
        }
      });
    });

    menu.querySelectorAll('.js-mobile-submenu-back').forEach(function (backEl) {
      backEl.addEventListener('click', function () {
        closeMobileSubmenu(menu);
      });
    });
  }

  function initMobileMenus() {
    mountAllMobileMenus();
    document.querySelectorAll('.js-mobile-menu-open').forEach(function (btn) {
      if (btn.dataset.mobileMenuBound === 'true') return;
      var menuId = btn.getAttribute('aria-controls');
      var menu = document.getElementById(menuId);
      if (!menu) return;
      bindMobileMenu(menu, btn);
      btn.dataset.mobileMenuBound = 'true';
    });
  }

  initMobileMenus();

  document.addEventListener('shopify:section:load', function () {
    initMobileMenus();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openMenu = document.querySelector('.mobile-menu[aria-hidden="false"]');
    if (!openMenu) return;
    var openBtn = document.querySelector('.js-mobile-menu-open[aria-expanded="true"]');
    if (openMenu.querySelector('.mobile-menu__view--sub.is-active')) {
      closeMobileSubmenu(openMenu);
    } else if (openBtn) {
      closeMobileMenu(openBtn, openMenu);
    }
  });
})();
